import React from 'react'
import { Route, Routes } from 'react-router-dom'

import { ERoutePath } from '../../consts/appRouter'
import {
  ArticlePage1,
  ArticlePage2,
  // ArticlePage3,
  // ArticlePage4,
  ArticlePage5,
  ArticlePage6,
  ArticlePage7,
  // ArticlePage8,
  // ArticlePage9,
  ArticlePage10Lazy,
  ArticlePage11Lazy,
  ArticlePage12Lazy,
  ArticlePage13Lazy,
  // CollectionRouter,
  // ArticlePage14Lazy,
  // CollectionRouter,
  // CollectionsPage,
  ArticlePage15Lazy,
  ArticlePage16Lazy,
  ArticlePage17Lazy,
  ArticlePage18Lazy,
  ArticlePage19Lazy,
  ArticlePage20Lazy,
  ArticlePage21Lazy,
  Articles,
  CollectionsArticle,
  FlatsPage,
  InvestmentPageLazy,
  NewCollectionsPage,
  NewMainPage,
} from '../../pages'
import { ProjectPage } from '../../pages/ProjectPage/ProjectPage'

export const AppRouter = () => {
  return (
    <Routes>
      <Route index element={<NewMainPage />} />
      {/*<Route path={ERoutePath.ARTICLES} element={<ArticlePage />} /> */}
      {/* <Route path={ERoutePath.NEW_MAIN_PAGE} element={<NewMainPage />} /> */}
      <Route path={ERoutePath.ARTICLES1} element={<ArticlePage1 />} />
      <Route path={ERoutePath.ARTICLES2} element={<ArticlePage2 />} />
      {/* <Route path={ERoutePath.ARTICLES3} element={<ArticlePage3 />} /> */}
      {/* <Route path={ERoutePath.ARTICLES4} element={<ArticlePage4 />} /> */}
      <Route path={ERoutePath.ARTICLES5} element={<ArticlePage5 />} />
      <Route path={ERoutePath.ARTICLES6} element={<ArticlePage6 />} />
      <Route path={ERoutePath.ARTICLES7} element={<ArticlePage7 />} />
      {/* <Route path={ERoutePath.ARTICLES8} element={<ArticlePage8 />} /> */}
      {/* <Route path={ERoutePath.ARTICLES9} element={<ArticlePage9 />} /> */}
      <Route path={ERoutePath.ARTICLES10} element={<ArticlePage10Lazy />} />
      <Route path={ERoutePath.ARTICLES11} element={<ArticlePage11Lazy />} />
      <Route path={ERoutePath.ARTICLES12} element={<ArticlePage12Lazy />} />
      <Route path={ERoutePath.ARTICLES13} element={<ArticlePage13Lazy />} />
      {/* <Route path={ERoutePath.ARTICLES14} element={<ArticlePage14Lazy />} /> */}
      <Route path={ERoutePath.ARTICLES15} element={<ArticlePage15Lazy />} />
      <Route path={ERoutePath.ARTICLES16} element={<ArticlePage16Lazy />} />
      <Route path={ERoutePath.ARTICLES17} element={<ArticlePage17Lazy />} />
      <Route path={ERoutePath.ARTICLES18} element={<ArticlePage18Lazy />} />
      <Route path={ERoutePath.ARTICLES19} element={<ArticlePage19Lazy />} />
      <Route path={ERoutePath.ARTICLES20} element={<ArticlePage20Lazy />} />
      <Route path={ERoutePath.ARTICLES21} element={<ArticlePage21Lazy />} />
      <Route path={ERoutePath.COLLECTIONS} element={<NewCollectionsPage />} />
      <Route path={ERoutePath.PROJECT} element={<ProjectPage />} />
      {/* <Route path={ERoutePath.LAYOUTPAGE} element={<LayoutPage />} /> */}
      <Route path={ERoutePath.FLATS} element={<FlatsPage />} />
      <Route path={ERoutePath.INVESTMENT} element={<InvestmentPageLazy />} />
      <Route
        path={ERoutePath.INVESTMENT_ARTICLE}
        element={<InvestmentPageLazy />}
      />
      <Route
        path={ERoutePath.COLLECTIONS_ARTICLE}
        element={<CollectionsArticle />}
      />
      <Route path={ERoutePath.ARTICLES} element={<Articles />} />
      {/* страница ошибки перекидываем на главную */}
      <Route path='*' element={<NewMainPage />} />
    </Routes>
  )
}
